import { useContext, } from 'react';

import UserContext from '../contexts/user';

export default function useUser () {
  const user = useContext(UserContext);

  return { user };
};
